webpackJsonp([51],{

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("c773a8da", content, true);

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.page-dealers-projects[data-v-1482f7fe]{padding:80px 50px 0}.switch-assign[data-v-1482f7fe]{width:120px}.company-disabled[data-v-1482f7fe]{opacity:.4}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration/page-dealers-projects.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,wCACE,mBAAqB,CACtB,AACD,gCACE,WAAa,CACd,AACD,mCACE,UAAa,CACd","file":"page-dealers-projects.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.page-dealers-projects[data-v-1482f7fe] {\n  padding: 80px 50px 0;\n}\n.switch-assign[data-v-1482f7fe] {\n  width: 120px;\n}\n.company-disabled[data-v-1482f7fe] {\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dealers-projects"},[_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"implementers","columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.projectCode)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"switch-assign"},[_c('div',{on:{"click":function($event){_vm.openModal(props.row)}}},[_c('v-switch',{staticClass:"mt-0",attrs:{"color":"info","hide-details":"","label":_vm.labelState(props.row.flagAssigned)},model:{value:(props.row.flagAssigned),callback:function ($$v) {_vm.$set(props.row, "flagAssigned", $$v)},expression:"props.row.flagAssigned"}})],1)]),_vm._v(" "),_c('td',[(props.row.flagCompanyParent)?_c('app-tooltip-button',{class:{ 'company-disabled': !props.row.flagAssigned },attrs:{"disabled":!props.row.flagAssigned,"color":"blue","icon":"location_city","text":"Compañías maestras"},on:{"click-icon":function($event){_vm.masterCompanies(props.row)}}}):_vm._e()],1)]}}])}),_vm._v(" "),_c('app-confirmation-modal',{attrs:{"confirmation-text":"Aceptar","show-modal":_vm.modalConfirmation.value,"text":_vm.modalContent},on:{"cancel":_vm.cancelModal,"confirm":_vm.confirm}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_projects_vue__ = __webpack_require__(860);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482f7fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_projects_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1482f7fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482f7fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-confirmation-modal',
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar'
		},
		confirmationText: {
			type: String,
			default: 'Eliminar'
		},
		loading: {
			default: false,
			type: Boolean
		},
		showModal: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?'
		},
		width: {
			type: Number,
			default: 500
		}
	}
});

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_confirmation_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da054f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_confirmation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"value":_vm.showModal,"width":_vm.width}},[_c('v-card',[_c('v-card-text',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.text)+"\n\t\t\t")]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"error","disabled":_vm.loading},on:{"click":function($event){_vm.$emit('confirm')}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.confirmationText)+"\n\t\t\t\t")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_confirmation_modal__ = __webpack_require__(581);



var projectList = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 20,
							isSelected: 2
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('distributaries/' + this.id + '/projects', { params: params });

					case 4:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function projectList() {
		return _ref.apply(this, arguments);
	};
}();

var deallocateButton = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(project) {
		var projectIds, body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						projectIds = [project.id];
						body = { projectIds: projectIds };
						_context2.prev = 2;
						_context2.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/projects', { data: body });

					case 5:
						this.showNotification('El proyecto fue desasignado correctamente');
						_context2.next = 12;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](2);

						this.$set(project, 'flagAssigned', !project.flagAssigned);
						this.showError();

					case 12:
						this.cancelModalConfirmation();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 8]]);
	}));

	return function deallocateButton(_x) {
		return _ref2.apply(this, arguments);
	};
}();

var assignRow = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(project) {
		var projectIds, body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						projectIds = [project.id];
						body = { projectIds: projectIds };
						_context3.prev = 2;
						_context3.next = 5;
						return this.$http.post('distributaries/' + Number(this.id) + '/projects', body);

					case 5:
						this.showNotification('El proyecto fue asignado correctamente');
						_context3.next = 12;
						break;

					case 8:
						_context3.prev = 8;
						_context3.t0 = _context3['catch'](2);

						this.$set(project, 'flagAssigned', !project.flagAssigned);
						this.showError();

					case 12:
						this.cancelModalConfirmation();

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[2, 8]]);
	}));

	return function assignRow(_x2) {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.projectList();
}

function assignmentDist(project) {
	var options = {
		1: this.assignRow,
		0: this.deallocateButton
	};
	options[Number(project.flagAssigned)].call(this, project);
}

function beforeRouteLeave(to, from, next) {
	var pathTo = to.path;
	var pathFrom = from.path;
	if (pathTo === pathFrom && to.name !== from.name) {
		next({ name: 'page-configuration' });
	} else {
		next();
	}
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
}

function labelState(assigned) {
	return assigned ? 'Asignado' : '';
}

function masterCompanies(project) {
	var codeProject = project.codeProject;

	this.$router.push({ name: 'assignment-master-companies', params: { codeProject: codeProject } });
}

function confirm() {
	this.assignmentDist(this.currentProject);
}

function modalContent() {
	var project = this.currentProject && this.currentProject.name;
	var distributer = this.$route.params.name;
	return '\xBFDesea asignar el proyecto ' + project + ' al distribuidor ' + distributer + '?';
}

function cancelModal() {
	var flagAssigned = this.currentProject.flagAssigned;

	this.currentProject.flagAssigned = !flagAssigned;
	this.cancelModalConfirmation();
}

function openModal(project) {
	this.currentProject = project;
	this.openModalConfirmation();
}

function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', visible: true }, { id: 2, name: 'Descripción', visible: true }, { id: 3, name: 'Código del proyecto', visible: true }, { id: 4, name: 'Asignar', visible: true }, { id: 5, name: 'Acciones', visible: true }],
		currentPage: 1,
		currentProject: null,
		lastPage: 0,
		params: {
			page: 1,
			search: null
		},
		rows: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-dealers-projects',
	beforeRouteLeave: beforeRouteLeave,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */],
		appConfirmationModal: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_confirmation_modal__["a" /* default */]
	},
	computed: {
		modalContent: modalContent
	},
	created: created,
	data: data,
	methods: {
		assignmentDist: assignmentDist,
		assignRow: assignRow,
		cancelModal: cancelModal,
		changePage: changePage,
		confirm: confirm,
		deallocateButton: deallocateButton,
		labelState: labelState,
		masterCompanies: masterCompanies,
		onSearch: onSearch,
		openModal: openModal,
		projectList: projectList
	},
	props: {
		id: {
			type: [Number, String]
		},
		name: {
			type: String,
			required: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.2d662b23360d57e2accd.js